import * as React from "react";
import { PropsWithChildren } from "react";

import { Maybe } from "../../types/thecookies";
import CustomItem, { ICustomItem } from "../CustomItem/CustomItem";
import DoNotMountComponent from "../DoNotMountComponent/DoNotMountComponent";

type PropsCustomList = PropsWithChildren<{
  data: Maybe<ICustomItem[]>;
  settings?: { isWithOutIcons?: boolean };
}>;

const CustomList: React.FC<PropsCustomList> = (props: PropsCustomList) => {
  if (!props.data) return <DoNotMountComponent sms={"Faltan datos para montar la lista"} log={props} />;

  return (
    <ul className={`m-custom-list`}>
      {props.data.map((item, index) => (
        <CustomItem key={index} data={item} settings={{ isWithOutIcons: props.settings?.isWithOutIcons ?? false }} />
      ))}
    </ul>
  );
};

export default CustomList;
